export default __webpack_public_path__ + "static/media/project-icon.58f59237.png";